module.exports = __webpack_public_path__ + "static/media/user_office.4fe81e3e.svg";